export const GET_REGISTRATIONS = "registrations/GET_REGISTRATIONS";
export const UPDATE_REGISTRATIONS = "registrations/UPDATE_REGISTRATIONS";
export const DELETE_REGISTRATIONS = "registrations/DELETE_REGISTRATIONS";